import { useContext } from "react";

import {
    DiscountsContext,
    type DiscountsContextValue,
} from "../context/DiscountsContext";

function useDiscounts(): DiscountsContextValue {
    const ctx = useContext(DiscountsContext);
    if (!ctx) {
        throw new Error("useDiscounts must be used within a DiscountsProvider");
    }
    return ctx;
}

export { useDiscounts };
